import * as React from 'react';
import { connect } from 'react-redux';
import ProdottoActions from './prodotto_actions';
import * as agui from 'arm-gui/dist/controls';
import { isNullOrUndefined } from 'util';

import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';
import ProdottoTable from './prodottoTable.jsx';
import UploadProdottoJSON from './UploadProdottoJSON.jsx';

class ProdottoOrginieDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoOrginieDetails.jsx] ';
        this.microCategoriaDetailsButton = this.microCategoriaDetailsButton.bind(this); 
        this.showPopUpUpload = this.showPopUpUpload.bind(this); 
        this.state = {
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        //faccio la chiamata REST per recuperare i dettagli 
        let idProdotto = null;
        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            // se non c'e la id sullo stato uso quello che c'e sullo store 
            idProdotto = this.props.prodottoOrigine.id
        } else {
            idProdotto = this.props.location.state.id
        }
        console.log(this.componentName + '[ID] ' + idProdotto);

        this.props.getPrdottoOrgineDetails(idProdotto);
    }

    microCategoriaDetailsButton() {
        console.log(this.componentName + 'microCategoriaDetailsButton');
        this.props.history.push({
            pathname: '/microCategorie/details', state: {
                id: this.props.prodottoOrigine.microCategoria.id
            }
        });
    }

    showPopUpUpload() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="card">
                <div className="card-header">
                    {this.props.prodottoOrigine && 
                        <>
                        <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DETTAGLIO_DEL_PRODOTTO', 'Dettaglio del Prodotto')} {this.props.prodottoOrigine.id} : {this.props.prodottoOrigine.nome}</h3>
                        <agui.aButton className="float-right mr-2" bs='primary' icon="fas fa-file-import" onClick={this.showPopUpUpload} inline={true} >{i18n('ARM_CORE_PRODUCT.SHARED.IMPORTA_VERSIONE', 'Importa Versione')}</agui.aButton>
                        </>
                    }
                </div>
                <div className="card-body">
                    {this.props.prodottoOrigine &&
                        <div>
                            <div>
                                <dl className="row mt-4 mb-4">
                                    <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}</dt>
                                    <dd className="col-sm-4 col-6">{this.props.prodottoOrigine.nome}</dd>
                                    <dt className="col-sm-2 col-6 mt-2">{i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro-categoria')}</dt>
                                    <dd className="col-sm-4 col-6">{this.props.prodottoOrigine.microCategoria ? <button type="button" className="btn btn-link" onClick={this.microCategoriaDetailsButton}>{this.props.prodottoOrigine.microCategoria.nome} </button> : null}</dd>
                                </dl>
                            </div>
                            <h3>{i18n('ARM_CORE_PRODUCT.SHARED.VERSIONI', 'Versioni')}</h3>
                            <ProdottoTable source="prodottoOrigineDetails" history={this.props.history} rows={this.props.prodottoOrigine.listaProdottiVersione}  ></ProdottoTable>
                        </div>
                    }

                </div>
                <div className="card-footer">
                    <div className="float-right mr-2">
                        <agui.aButton bs="secondary" className="float-right mr-2" href="#/prodotto/listOrigine" >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                    </div>
                </div>

                <UploadProdottoJSON isVersione={true} show={this.state.showConfirm} close={this.showPopUpUpload} />
            </div>
        );
    }
};


function mapStateToProps(state, ownProps) {
    return {
        prodottoOrigine: state.prodotto.prodottoOrigine,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getPrdottoOrgineDetails(id) {
            return dispatch(ProdottoActions.getPrdottoOrgineDetails(id));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProdottoOrginieDetails);



